module.exports = __webpack_public_path__ + "img/invest_list4.3217fff3.png";